/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const planIndexQueryDataSchema = z.object({
	profile: z.string().uuid().nullable().optional(),
})

export type PlanIndexQueryDataSchema = z.infer<typeof planIndexQueryDataSchema>
